<template lang="html">
  <div id="recurrentReservePanel">
    <!-- <div>
      <span>繰り返す頻度：</span><select name="recFreq" v-model="freq" @change="onChange()">
        <option value="WEEKLY" selected>
          毎週
        </option>
        <option value="DAILY">
          毎日
        </option>
        <option value="MONTHLY">
          毎月
        </option>
      </select>
    </div>
    <div>
      <span>期間:</span>
      <select name="recSpan" v-model="span" @change="onChange()">
        <option value="7" selected>一週間</option>
        <option value="30" selected>1ヶ月</option>
        <option value="90">3ヶ月</option>
        <option value="180">6ヶ月</option>
        <option value="365">1年</option>
      </select>
    </div> -->
  </div>
</template>

<script>
import {
  RRULE_UPDATE
} from '@/vuex/mutation_types'
export default {
  name: 'recurrent-panel',
  data () {
    return {
      freq: 'WEEKLY',  // DAILY: 毎日, WEEKLY:毎週, MONTHLY:毎月
      byday: this.$store.state.curDate.getDay(), // 0:日曜 .. 6: 土曜
      span: '0' // 日単位
    }
  },
  methods: {
    onChange () {
      let theday = this.$store.state.curDate
      const DTSTART = this.getDateFormated(theday)
      let finday = new Date(theday)
      finday.setDate(finday.getDate() + parseInt(this.span))
      const UNTIL = this.getDateFormated(finday)
      if (this.freq === 'WEEKLY' || this.freq === 'MONTHLY') {
        let rrule = `DTSTART: ` + DTSTART + `
RRULE:FREQ=` + this.freq +
        `;UNTIL=` + UNTIL +
        `;BYDAY=` + this.getBYDAYString(this.byday)
        this.$store.commit(RRULE_UPDATE, rrule)
        return
      } else {
        let rrule = `DTSTART: ` + DTSTART + `
        RRULE:FREQ=` + this.freq + `;UNTIL=` + UNTIL
        this.$store.commit(RRULE_UPDATE, rrule)
        return
      }
    },
    getBYDAYString (day) {
      switch (day) {
        case 0:
          return 'SU'
        case 1:
          return 'MO'
        case 2:
          return 'TU'
        case 3:
          return 'WE'
        case 4:
          return 'TH'
        case 5:
          return 'FR'
        case 6:
          return 'SA'
        default:
          break
      }
    },
    getDateFormated (date) {
      let day = date.getDate()
      // Date.monthは0から始まることに注意
      let month = date.getMonth() + 1
      const year = date.getFullYear()
      if (day < 10) {
        day = '0' + day
      }
      if (month < 10) {
        month = '0' + month
      }
      return '' + year + month + day
    }
  },
  created () {
    let theday = this.$store.state.curDate
    const DTSTART = this.getDateFormated(theday)
    // 月末の日まで
    let finday = new Date(theday.getFullYear(), theday.getMonth() + 1, 0)
    const UNTIL = this.getDateFormated(finday)
    if (this.freq === 'WEEKLY' || this.freq === 'MONTHLY') {
      let rrule = `DTSTART: ` + DTSTART + `
RRULE:FREQ=` + this.freq +
      `;UNTIL=` + UNTIL +
      `;BYDAY=` + this.getBYDAYString(this.byday)
      this.$store.commit(RRULE_UPDATE, rrule)
      return
    } else {
      let rrule = `DTSTART: ` + DTSTART + `
      RRULE:FREQ=` + this.freq + `;UNTIL=` + UNTIL
      this.$store.commit(RRULE_UPDATE, rrule)
      return
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// SpRecurrentReservePanel.vue?51854181